import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CursorComponent } from './cursor.component';
import { CursorOnHoverDirective } from './cursor-on-hover.directive';

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [CursorComponent, CursorOnHoverDirective],
  exports: [CursorComponent, CursorOnHoverDirective],
})
export class CursorModule {}
